module.exports = __webpack_public_path__ + "img/collection-engagementRingsCharisma@2x.59493cc.jpg";